/* tslint:disable */
/* eslint-disable */
/**
 * Airline API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 */
export const ExerciseStepResult = {
    Success: 'success',
    Failure: 'failure',
    TechnicalError: 'technical_error'
};
export function ExerciseStepResultFromJSON(json) {
    return ExerciseStepResultFromJSONTyped(json, false);
}
export function ExerciseStepResultFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function ExerciseStepResultToJSON(value) {
    return value;
}
